// extracted by mini-css-extract-plugin
module.exports = {"header":"AccessabilityDeclaration_header__3wL2B","headerText":"AccessabilityDeclaration_headerText__54DpH","textClass":"AccessabilityDeclaration_textClass__1hUOw"};